import React, { Component } from 'react'
import OrderDetail from '../../../components/orders/OrderDetail'

export default class DetailOrder extends Component{
  render() {
    return(
      <OrderDetail {...this.props}/>
    )
  }
}